<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: leftcolumn }">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Is Item?">
              <a-radio-group
                buttonStyle="solid"
                @change="handleis_item"
                :disabled="isItem"
                v-decorator="[
                  'is_item',
                  { rules: [{ required: true }], initialValue: 'yes' },
                ]"
              >
                <!-- , initialValue: initialData.informasi.inc_qc -->
                <a-radio-button value="yes">Yes</a-radio-button>
                <a-radio-button value="no">No</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-form-item label="Used For" v-if="trigered.used_for">
              <a-radio-group
                v-decorator="[
                  'used_for',
                  { rules: [{ required: true }], initialValue: '2' },
                ]"
                @change="handleUseFor"
              >
                <a-radio value="2">Tax</a-radio>
                <a-radio value="3">Shipping</a-radio>
                <a-radio value="4">Etc</a-radio>
                <a-radio value="1">Discount</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="Category" v-if="trigered.is_item=='yes'" hidden>
              <a-radio-group
                
                @change="handleis_aset"
                v-decorator="[
                  'is_aset',
                  { rules: [{ required: true }], initialValue: jenis_anggaran=='05' ? 'yes' : 'no' },
                ]"
              >
                <a-radio value="no">Item Inventory</a-radio>
                <a-radio value="yes">Item Aset</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Tax Type" v-if="trigered.is_item == 'no' && trigered.tax">
          <a-select
            v-decorator="[
              'tax_type',
              {
                rules: [{ required: true }],
                initialValue: undefined,
              },
            ]"
            @change="taxTypeChange"
            showSearch
            option-filter-prop="children"
            :filter-option="filterOption"
          >
            <a-select-option
                v-for="item in getType_tax"
                :key="item.value"
                :value="item.value"
              >
              {{item.text}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Tax Bearer Supplier?" v-if="trigered.is_item == 'no' && trigered.tax">
              <a-radio-group
                buttonStyle="solid"
                v-decorator="[
                  'tax_bearer',
                  { rules: [{ required: true }], initialValue: initialTaxBearer },
                ]"
                :disabled="trigered.disabledTaxBearer"
                @change="changeTaxBearer"
              >
                <a-radio-button value="1">Yes</a-radio-button>
                <a-radio-button value="0">No</a-radio-button>
              </a-radio-group>
            </a-form-item>
        <a-form-item
          label="PP Detail"
          v-if="
            trigered.is_item == 'yes' ||
            (trigered.is_item == 'no' && trigered.dis_tax_type)
          "
        >
          <a-tooltip placement="topLeft" v-if="selectedDetail !== ''">
            <template slot="title">
              <span>{{
                selectedDetail[0].nama_barang +
                " - " +
                selectedDetail[0].kode_anggaran
              }}</span>
            </template>
            <a-select
              showSearch
              @search="handleppdtl"
              @change="handleDetail"
              class="select-between"
              optionFilterProp="children"
              :filterOption="filterOption"
              v-decorator="[
                'selectedPPdtl',
                { rules: [{ required: true }], initialValue: undefined },
              ]"
            >
              <a-select-option
                v-for="item in ppdetillist"
                :key="item.id_pp_dtl"
              >
                <div class="option-between">
                  <div class="option-between__left">
                    {{ item.nama_barang }} - {{ item.kode_anggaran }}
                  </div>
                  <div class="option-between__right">
                    {{
                      formatCurrency(
                        item.currency,
                        parseFloat(item.nilai_dtl_pp)
                      )
                    }}
                  </div>
                </div>
              </a-select-option>
            </a-select>
          </a-tooltip>
          <a-select
            showSearch
            @search="handleppdtl"
            @change="handleDetail"
            class="select-between"
            optionFilterProp="children"
            :filterOption="filterOption"
            v-decorator="[
              'selectedPPdtl',
              { rules: [{ required: true }], initialValue: undefined },
            ]"
            v-else
          >
            <a-select-option v-for="item in ppdetillist" :key="item.id_pp_dtl">
              <div class="option-between">
                <div class="option-between__left">
                  {{ item.nama_barang }} - {{ item.kode_anggaran }}
                </div>
                <div class="option-between__right">
                  {{
                    formatCurrency(item.currency, parseFloat(item.nilai_dtl_pp))
                  }}
                </div>
              </div>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Item PN" v-if="trigered.pn && !isAset">
          <v-select
            taggable
            clearable
            class="m-select"
            @input="handlePN"
            :options="dataPN"
            v-model="selectedPN"
            label="item_pn_concat"
          ></v-select>
        </a-form-item>
        <a-form-item label="Aset PN" v-if="trigered.pn && isAset">
          <v-select
            taggable
            clearable
            class="m-select"
            @input="handleAset"
            :options="dataAset"
            v-model="selectedPN"
            label="item_pn_concat"
          ></v-select>
        </a-form-item>
        <a-form-item :label="!isAset ? 'Item Name' : 'Aset Name'">
          <a-input
            autocomplete="off"
            :maxLength=500
            v-decorator="['nama_barang', { rules: [{ required: true }] }]"
            v-bind:onpaste="pastemax500"
          ></a-input>
        </a-form-item>
        <a-row :gutter="8" v-if="trigered.qty_unit">
          <a-col :span="12">
            <a-form-item label="Quantity">
              <a-input-number
                :min="1"
                :max="10000"
                class="m-width-full"
                v-decorator="[
                  'jumlah',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
                @change="convertingqty"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Unit">
              <a-auto-complete
                allowClear
                :dataSource="initialSatuan"
                placeholder="input here"
                v-decorator="['satuan', { rules: [{ required: true }] }]"
                :filterOption="handleSatuan"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8">
          <a-col :span="jenis_anggaran=='05' ? 12 : 24">
            <a-form-item label="Value" v-if="!trigered.cur">
              <a-input-number
                :min="0"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'harga',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
                @change="convertinghrg"
              />
              <div v-if="mata_uang !== 'IDR'" class="m-form-description-small">Total value to IDR : {{convert_value}}</div>
            </a-form-item>
          </a-col>
          <a-col :span="jenis_anggaran=='05' ? 12 : 0">
            <div class="ant-col ant-form-item-label">&nbsp;</div>
              <!-- <a-radio-group
                buttonStyle="solid"
                v-decorator="[
                  'isinventaris',
                  { rules: [{ required: true }], initialValue: '1' },
                ]"
              >
                <a-radio-button value="1">Yes</a-radio-button>
                <a-radio-button value="0">No</a-radio-button>
              </a-radio-group> -->
              <a-input v-if="trigered.is_item=='yes' && jenis_anggaran=='05'" v-model="lbl_inv" class="labelingInventaris" disabled/>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="Option" v-if="trigered.cur">
              <a-select
                v-decorator="[
                  'cur_type',
                  { rules: [{ required: true }], initialValue: 'currency' },
                ]"
                @change="handleOption"
                :disabled="!trigered.optionNominal"
              >
                <a-select-option value="currency">Nominal</a-select-option>
                <a-select-option value="percentage">Percentage</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="18">
            <a-form-item label="Value" v-if="trigered.cur">
              <a-input-number
                v-if="trigered.percentage == false"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'harga',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
                @change="convertinghrg"
              />
              <a-input-number
                v-else
                :min="0"
                :max="100"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'harga',
                  { rules: [{ required: true }, { validator: checkPrice }] },
                ]"
                @change="convertinghrg"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <p v-if="mata_uang !== 'IDR'" class="margin-bottom">
          Total value to IDR: {{ convert_value }}
          <br />
        </p> -->
        <a-form-item label="Note" v-if="trigered.is_item == 'yes'">
          <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="[
              'catatan_dtl',
              { rules: [{ required: false }] },
            ]"
          />
        </a-form-item>
        <!-- <a-divider class="margin-bottom-small">or</a-divider>
        <a-form :form="formUpload">
          <a-form-item>
            <h4>Upload Excel File</h4>
            <p>
              If You Don't Have a File Upload Template Please Click
              <a-button
                class="padding-remove"
                type="link"
                @click="handleDownload"
                >Download Template</a-button
              >
            </p>
            <a-upload
              accept=".xls, .xlsx"
              :showUploadList="true"
              :fileList="push"
              v-decorator="['file_transfer']"
              :remove="handleRemoveList"
              :beforeUpload="beforeUpload"
            >
              <a-button :disabled="trigered.is_item == 'no'"> 
                <a-icon type="upload" />&nbsp;Select File </a-button>
            </a-upload>
            <a-divider v-if="getScreen"></a-divider>
          </a-form-item>
        </a-form> -->
        <br />
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleNewItem"
            block
            type="primary"
            html-type="submit"
            :loading="newLoading"
            ref="addMainBtn"
            v-decorator="['addMainBtn']"
            >Add</a-button
          >
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: rightcolumn }">
        <a-card class="m-height-full m-display-flex nowrap flex-column">
          <div slot="title">
            <span>Purchase List</span>
          </div>
          <template slot="extra" v-if="!getScreen">
            <a-button
              :loading="collectiveLoading"
              @click="onCollective"
              class="margin-right-small"
              icon="edit"
              >Collective</a-button
            >
            <a-button @click="handleExpand()">
              <span>{{ labelExpand }}</span>
            </a-button>
          </template>
          <div class="body-flex">
            <a-table
              v-if="!getScreen"
              :columns="columns"
              :dataSource="getCountWeb"
              :pagination="pagination"
              size="small"
              :scroll="{ x: 700 }"
              bordered
            >
              <template slot="itemPN" slot-scope="index, item">
                <b>
                  <span>{{ item.values.nama_barang }}</span>
                </b>
                <br />
                <span>
                  {{ item.values.item_pn ? "PN : " + item.values.item_pn : "" }} 
                </span>
                <br />
                <small><b>( {{item.type_item=="1" ? "ASET" : "ITEM"}} )</b></small>
              </template>
              <template slot="isinventaris" slot-scope="item">
                {{item ? (item.values.isinventaris == '1' ? "Yes" : "No") : ""}}
              </template>
              <template slot="note" slot-scope="item">
                {{item ? item.values.catatan_dtl : ''}}
              </template>
              <template slot="itemPPDtl" slot-scope="index, item">
                <b>{{ item.pp_nama_barang }}</b>
                <br />
                <i>{{ item.pp_kode_anggaran }}</i>
                <a-alert
                  type="error"
                  banner
                  v-if="
                    item.pp_kode_anggaran == null || item.pp_kode_anggaran == ''
                  "
                  message="item anggaran cannot be empty"
                />
              </template>
              <template slot="operation" slot-scope="index, item">
                <a-button-group v-if="item">
                  <a-button
                    type="primary"
                    :disabled="totalDiscList > 0"
                    @click="handleEditModal(item)"
                  >
                    <a-icon type="edit" />
                  </a-button>
                  <a-button type="danger"
                    :disabled="mode=='Edit' && item.values.jumlah_diterima>0"
                    @click="handleRemove(item.values)">
                    <a-icon type="close"/>
                  </a-button>
                </a-button-group>
              </template>
            </a-table>
            <a-list
              v-else
              itemLayout="vertical"
              :dataSource="listPembelian"
              :pagination="pagination"
            >
              <Empty
                v-if="listPembelian ? listPembelian.length <= 0 : listPembelian"
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <a-row slot="title" type="flex" justify="space-between">
                    <a href="#">{{ item.values.nama_barang }}</a>
                  </a-row>
                  <div slot="description" class="margin-remove">
                    <span v-if="item.values.kategori === '1'">BHP</span>
                    <span v-else-if="item.values.kategori === '0'"
                      >Non BHP</span
                    >
                    <span v-else-if="item.values.kategori === '2'">Lembar</span>
                    <div class="m-display-flex space-between">
                      <span>
                        {{ item.values.jumlah }}&nbsp;{{ item.values.satuan }}
                      </span>

                      <div>
                        <h4 class="margin-remove m-text-align right">
                          @ {{ formatCurrency(mata_uang, item.values.harga) }}
                        </h4>
                      </div>
                    </div>
                    <a-divider class="margin-small" />
                    <h4 class="margin-remove m-text-align right">
                      {{ formatCurrency(mata_uang, item.values.hargaTotal) }}
                    </h4>
                  </div>
                </a-list-item-meta>
                <a-button-group>
                  <a-button type="primary" @click="handleEditModal(item)">
                    <a-icon type="edit" />&nbsp;Edit
                  </a-button>
                  <a-button type="danger" @click="handleRemove(item.values)">
                    <a-icon type="close" />&nbsp;Remove
                  </a-button>
                </a-button-group>
              </a-list-item>
            </a-list>
          </div>
        </a-card>
        <div class="m-price-total" style="margin-bottom:0px!important">
          <div class="footer-list">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
                <h3 class="margin-remove m-text-align right">Sub Total :</h3>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
                <h3 class="m-text-align">
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="totalPrice"
                  />
                </h3>
              </a-col>
            </a-row>
          </div>
          <a-divider class="margin-medium" />
          <div v-for="item in getListDisc" :key="item.key" class="footer-list">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <span
                  v-if="item.values.cur_type !== 'percentage'"
                  class="m-text-align footer-list footer-light" style="padding-right: 15px!important;"
                  >{{ item.item_name }} :</span
                >
                <span v-else class="m-text-align footer-list footer-light" style="padding-right: 15px!important;"
                  >{{ item.item_name }} ({{ item.values.harga + "%" }}) :</span
                >
              </a-col>
              <a-col :span="3">
                <a-button-group class="m-text-align right footer-list">
                  <a-button
                    type="primary"
                    size="small"
                    @click="handleEditModal(item)"
                  >
                    <a-icon type="edit" />
                  </a-button>
                  <a-button
                    type="danger"
                    size="small"
                    @click="handleRemove(item.values)"
                  >
                    <a-icon type="close" />
                  </a-button>
                </a-button-group>
              </a-col>
              <a-col :span="9">
                <span
                  class="m-text-align footer-light"
                  :style="item.unit_price < 0 ? 'color:red' : 'color:black'"
                  v-if="item.values.cur_type !== 'percentage'"
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="item.unit_price"
                  />
                </span>
                <span
                  class="m-text-align footer-light"
                  :style="
                    (totalPrice * item.values.harga) / 100 < 0
                      ? 'color:red'
                      : 'color:black'
                  "
                  v-else
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="(totalPrice * item.values.harga) / 100"
                  />
                </span>
              </a-col>
            </a-row>
          </div>
          <div class="footer-list">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
                <h3 class="margin-remove m-text-align right">
                  Total Discount :
                </h3>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
                <h3 class="m-text-align">
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="totalDiscList"
                  />
                </h3>
              </a-col>
            </a-row>
          </div>
          <a-divider class="margin-medium" />
          <div v-for="item in getListTax" :key="item.key" class="footer-list">
            <a-row :gutter="8" style="padding-top:5px!important">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <span
                  v-if="item.values.cur_type !== 'percentage'"
                  class="m-text-align footer-list footer-light" style="padding-right: 15px!important;"
                  >{{item.values.tax_type ? toTextTax(item)+" >" : ''}} {{ item.item_name }} :</span
                >
                <span v-else class="m-text-align footer-list footer-light" style="padding-right: 15px!important;"
                  >{{item.values.tax_type ? toTextTax(item)+" >" : ''}} {{ item.item_name }} ({{ item.values.harga + "%" }}) :</span
                >
                <span class="m-text-align" style="float:right;padding-right: 15px!important;"
                  v-if="item.values.used_for=='2' && item.values.tax_type"><b><i><small>({{ item.values.tax_bearer=='0' ? 'Tax bearer : INFOGLOBAL' : 'Tax bearer : SUPPLIER' }})</small></i></b>
                </span>
              </a-col>
              <a-col :xs="{ span: 6 }" :lg="{ span: 3 }">
                <a-button-group
                  class="m-text-align right footer-list footer-light"
                >
                  <a-button
                    type="primary"
                    size="small"
                    @click="handleEditModal(item)"
                  >
                    <a-icon type="edit" />
                  </a-button>
                  <a-button
                    type="danger"
                    size="small"
                    @click="handleRemove(item.values)"
                  >
                    <a-icon type="close" />
                  </a-button>
                </a-button-group>
              </a-col>
              <a-col :xs="{ span: 18 }" :lg="{ span: 9 }">
                <span
                  class="m-text-align footer-light"
                  :style="item.unit_price < 0 ? 'color:red' : 'color:black'"
                  v-if="item.values.cur_type !== 'percentage'"
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="item.unit_price"
                  />
                </span>
                <span
                  class="m-text-align footer-light"
                  :style="
                    ((totalPrice - totalDiscList) * item.values.harga) / 100 < 0
                      ? 'color:red'
                      : 'color:black'
                  "
                  v-else
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="((totalPrice - totalDiscList) * item.values.harga) / 100"
                  />
                </span>
              </a-col>
            </a-row>
          </div>
          <div class="footer-list">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
                <h3 class="margin-remove m-text-align right">Total Tax :</h3>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
                <h3 class="m-text-align">
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="nilaiPajak"
                  />
                </h3>
              </a-col>
            </a-row>
          </div>
          <a-divider class="margin-medium" />
          <div class="footer-list">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
                <h3 class="margin-remove m-text-align right">
                  Rounding :
                </h3>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
                <h3 class="m-text-align">
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="roundingValue"
                    :deci2="true"
                  />
                </h3>
              </a-col>
            </a-row>
          </div>
          <a-divider class="margin-medium" />
          <div
            v-for="item in getListUsualShipp"
            :key="item.key"
            class="footer-list footer-light"
          >
            <a-row :gutter="8" style="padding-top:5px!important">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <span
                  v-if="item.values.cur_type !== 'percentage'"
                  class="m-text-align footer-list footer-light"
                  >{{ item.item_name }} :</span
                >
                <span v-else class="m-text-align footer-list footer-light"
                  >{{ item.item_name }} ({{ item.values.harga + "%" }}) :</span
                >
              </a-col>
              <a-col :span="3">
                <a-button-group
                  class="m-text-align right footer-list footer-light"
                >
                  <a-button
                    type="primary"
                    size="small"
                    @click="handleEditModal(item)"
                  >
                    <a-icon type="edit" />
                  </a-button>
                  <a-button
                    type="danger"
                    size="small"
                    @click="handleRemove(item.values)"
                  >
                    <a-icon type="close" />
                  </a-button>
                </a-button-group>
              </a-col>
              <a-col :span="9">
                <span
                  class="m-text-align footer-light"
                  :style="item.unit_price < 0 ? 'color:red' : 'color:black'"
                  v-if="item.values.cur_type !== 'percentage'"
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="item.unit_price"
                  />
                </span>
                <span
                  class="m-text-align footer-light"
                  :style="
                    (totalPrice * item.values.harga) / 100 < 0
                      ? 'color:red'
                      : 'color:black'
                  "
                  v-else
                >
                  <CurrencyJustified
                    :currencyValue="mata_uang"
                    :valueNumber="(totalPrice * item.values.harga) / 100"
                  />
                </span>
              </a-col>
            </a-row>
          </div>
          <a-statistic
            title="Total Bill"
            :value="formatCurrency(mata_uang, grandTotal+roundingValue)"
            class="margin-top m-text-align right"
          />
        </div>
        <i v-if="anyPPH" style="color:red">* PPh is not calculated </i>
      </a-col>
    </a-row>
    <a-modal
      v-model="editModal"
      @ok="handleEditModal"
      @cancel="handleClose"
      :maskClosable="false"
      :footer="null"
    >
      <span slot="title"> <a-icon type="form" />&nbsp;Change </span>

      <a-form :form="modalForm">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Is Item?">
              <a-radio-group
                buttonStyle="solid"
                @change="handleis_item"
                :disabled="true"
                v-decorator="[
                  'is_item',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.is_item,
                  },
                ]"
              >
                <!-- , initialValue: initialData.informasi.inc_qc -->
                <a-radio-button value="yes">Yes</a-radio-button>
                <a-radio-button value="no">No</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-form-item label="Used For" v-if="trigered.is_item == 'no'">
              <a-radio-group
                :disabled="true"
                v-decorator="[
                  'used_for',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.used_for,
                  },
                ]"
                @change="handleUseFor"
              >
                <a-radio value="2">Tax</a-radio>
                <a-radio value="3">Shipping</a-radio>
                <a-radio value="4">Etc</a-radio>
                <a-radio value="1">Discount</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="Category" hidden>
              <a-radio-group
                :disabled="true"
                v-decorator="[
                  'is_aset',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.type_item=='1' ? 'yes' : 'no',
                  },
                ]"
              >
                <!-- , initialValue: initialData.informasi.inc_qc -->
                <a-radio value="no">Item Inventory</a-radio>
                <a-radio value="yes">Item Aset</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="Tax Type" v-if="trigered.is_item == 'no' && trigered.tax">
          <a-select
            v-decorator="[
              'tax_type',
              {
                rules: [{ required: true }],
                initialValue: editData.values.tax_type,
              },
            ]"
            disabled
            showSearch
            option-filter-prop="children"
            :filter-option="filterOption"
            @change="taxTypeChange2"
          >
            <a-select-option
                v-for="item in getType_tax"
                :key="item.value"
                :value="item.value"
              >
              {{item.text}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Tax Bearer Supplier?" v-if="trigered.is_item == 'no' && trigered.tax">
          <a-radio-group
            buttonStyle="solid"
            v-decorator="[
              'tax_bearer',
              { rules: [{ required: true }], initialValue: editData.values.tax_bearer },
            ]"
            :disabled="true"
            @change="changeTaxBearer"
          >
            <a-radio-button value="1">Yes</a-radio-button>
            <a-radio-button value="0">No</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="PP Detail"
          v-if="
            this.trigered.is_item == 'yes' ||
            (this.trigered.is_item == 'no' && trigered.dis_tax_type )
          "
        >
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{
              (selectedDetail2 ? selectedDetail2[0].nama_barang : "") +
              " - " +
              (selectedDetail2? selectedDetail2[0].kode_anggaran : "")
            }}</span>
          </template>

          <a-select
            showSearch
            allowClear
            @search="handleppdtl"
            @change="handleDetail2"
            optionFilterProp="children"
            :filterOption="filterOption"
            v-decorator="[
              'selectedPPdtl',
              {
                rules: [{ required: true }],
                initialValue: editData.values.selectedPPdtl,
              },
            ]"
            :disabled="true"
          >
            <a-select-option
              v-for="item in ppdetillist"
              :key="item.id_pp_dtl"
              :value="item.id_pp_dtl"
            >
              <div div class="option-between">
                <div class="option-between__left">
                  {{ item.nama_barang }} - {{ item.kode_anggaran }}
                </div>
                <div class="option-between__right">
                  {{
                    formatCurrency(
                      item.currency,
                      parseFloat(item.nilai_dtl_pp)
                    )
                  }}
                </div>
              </div>
            </a-select-option>
          </a-select>
          </a-tooltip>
        </a-form-item>
        <a-form-item label="Item PN" v-if="trigered.is_item == 'yes' && editData.type_item!=='1'">
          <v-select
            taggable
            clearable
            class="m-select"
            @input="handlePN"
            :options="dataPN"
            v-model="selectedPNm"
            label="item_pn_concat"
            :disabled="mode=='Edit' && editData.values.jumlah_diterima>0"
          ></v-select>
        </a-form-item>
        <a-form-item label="Aset PN" v-if="trigered.is_item == 'yes' && editData.type_item=='1'">
          <v-select
            taggable
            clearable
            class="m-select"
            @input="handleAset"
            :options="dataAset"
            v-model="selectedPNm"
            label="item_pn_concat"
            :disabled="mode=='Edit' && editData.values.jumlah_diterima>0"
          ></v-select>
        </a-form-item>
        <a-form-item label="Item Name">
          <a-input
            autocomplete="off"
            :maxLength=500
            v-bind:onpaste="pastemax500"
            v-decorator="[
              'nama_barang',
              {
                rules: [{ required: true }],
                initialValue: editData.values.nama_barang,
              },
            ]"
            :disabled="mode=='Edit' && editData.values.jumlah_diterima>0"
          ></a-input>
        </a-form-item>
        <a-row :gutter="8" v-if="trigered.is_item == 'yes'">
          <a-col :span="12">
            <a-form-item label="Quantity">
              <a-input-number
                :min="1"
                :max="10000"
                class="m-width-full"
                v-decorator="[
                  'jumlah',
                  {
                    rules: [{ required: true }, { validator: checkPrice }],
                    initialValue: editData.values.jumlah,
                  },
                ]"
                @change="convertingmodalqty"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Unit">
              <a-auto-complete
                allowClear
                :dataSource="initialSatuan"
                placeholder="input here"
                v-decorator="[
                  'satuan',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.satuan,
                  },
                ]"
                :disabled="mode=='Edit' && editData.values.jumlah_diterima>0"
                :filterOption="handleSatuan"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8" v-if="trigered.is_item == 'no'">
          <a-col :span="12">
            <a-form-item label="Option">
              <a-select
                v-decorator="[
                  'cur_type',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.values.cur_type,
                  },
                ]"
                @change="optionchange"
                :disabled="(mode=='Edit' && editData.values.jumlah_diterima>0) || !trigered.optionNominal"
              >
                <a-select-option value="currency">Nominal</a-select-option>
                <a-select-option value="percentage">Percentage</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Value">
              <a-input-number
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'harga',
                  {
                    rules: [{ required: true }, { validator: checkPrice }],
                    initialValue: parseFloat(editData.values.harga),
                  },
                ]"
                @change="convertingmodalhrg"
                v-on:keydown.enter.prevent="preventEnterButtonModal"
                :disabled="mode=='Edit' && editData.values.jumlah_diterima>0"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8" v-if="trigered.is_item == 'yes'">
          <a-col :span="12">
            <a-form-item label="Value" v-if="trigered.is_item == 'yes'">
              <a-input-number
                :min="0"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'harga',
                  {
                    rules: [{ required: true }, { validator: checkPrice }],
                    initialValue: parseFloat(editData.values.harga),
                  },
                ]"
                @change="convertingmodalhrg"
                :disabled="mode=='Edit' && editData.values.jumlah_diterima>0"
              />
              <div v-if="mata_uang !== 'IDR'" class="m-form-description-small">Total value to IDR : {{modalconvert_value}}</div>
            </a-form-item>
            <!-- <p v-if="mata_uang !== 'IDR'" class="margin-bottom">
              Total value to IDR: {{ modalconvert_value }} 
              <br />
            </p> -->
          </a-col>
          <a-col :span="jenis_anggaran=='05' ? 12 : 0">
            <div class="ant-col ant-form-item-label">&nbsp;</div>
              <!-- <a-radio-group
                buttonStyle="solid"
                v-decorator="[
                  'isinventaris',
                  { rules: [{ required: true }], initialValue: editData.values.isinventaris },
                ]"
              >
                <a-radio-button value="1">Yes</a-radio-button>
                <a-radio-button value="0">No</a-radio-button>
              </a-radio-group> -->
              <a-input v-if="trigered.is_item=='yes' && jenis_anggaran=='05'" v-model="lbl_inv" class="labelingInventaris" disabled/>
            </a-col>
          </a-row>
          <a-form-item label="Note" v-if="this.trigered.is_item == 'yes'">
            <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="[
                'catatan_dtl',
                { rules: [{ required: false }],initialValue: editData.values.catatan_dtl },
              ]"
            />
          </a-form-item>
          <a-button
            @click="handleModalEdit(editData.key)"
            block
            type="danger"
            html-type="submit"
            v-decorator="['change']"
            ref="change"
            >Change</a-button
          >
      </a-form>
    </a-modal>

    <Collective
      v-if="isCollective"
      :close="handleCloseCollective"
      :datasource="listPembelian"
    >
      <div slot="title"><a-icon type="edit" />&nbsp;Edit Collective</div>
      <template slot="content">
        <a-form class="margin-bottom" :form="formCollective">
          <a-form-item label="PP Detail">
            <a-select
              showSearch
              class="select-between"
              placeholder="Select PP"
              option-filter-prop="children"
              :filter-option="filterOption"
              v-decorator="[
                'kode_anggaran',
                {
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option
                v-for="item in ppdetillist"
                :key="item.id_pp_dtl"
                :disabled="item.nilai_dtl_pp == '0' ? true : false"
              >
                <div class="option-between">
                  <div class="option-between__left">
                    <b>{{ item.nama_barang }}</b>
                    <small> | </small>
                    <small>{{ item.kode_anggaran }}</small>
                  </div>
                  <div class="option-between__right">
                    <small>
                      {{
                        formatCurrency(
                          item.currency,
                          item.nilai_dtl_pp
                        ).replace(",00", "")
                      }}
                    </small>
                  </div>
                </div>

                <!-- <div class="select-option">
                  <div v-if="!getScreen">
                    <h4>{{ item.nama_barang }}</h4>
                    <small>|</small>
                    <small>{{ item.kode_anggaran }}</small>
                  </div>
                  <h4 v-else>{{ item.nama_barang }}</h4>
                  <small>
                    {{
                    formatCurrency(item.currency,item.nilai_dtl_pp)
                    .replace(",00", "")
                    }}
                  </small>
                </div> -->
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
        <a-table
          :columns="columns"
          :dataSource="mListPembelian"
          :pagination="false"
          size="small"
          :scroll="{ x: 610 }"
          :loading="loadingTable"
          bordered
        >
          <div slot="itemPPDtl" slot-scope="item">
            <h4 class="margin-remove">{{ item.deskripsi }}</h4>
            <small
              >{{ item.pp_nama_barang }}
              {{
                item.pp_kode_anggaran ? " | " + item.pp_kode_anggaran : ""
              }}</small
            >
            <a-alert
              type="error"
              banner
              v-if="
                item.pp_kode_anggaran == null || item.pp_kode_anggaran == ''
              "
              message="item anggaran cannot be empty"
            />
          </div>
          <template slot="operation" slot-scope="index, item">
            <a-checkbox
              :checked="
                selected.filter((obj) => obj.key == item.key).length == 0
                  ? false
                  : true
              "
              @change="handleCheck"
              :value="item"
            />
          </template>
        </a-table>
      </template>
      <template slot="resume">
        <h3>Sub Total : {{ formatCurrency(
                          this.mata_uang,
                          this.totalSelected
                        ).replace(",00", "") }}</h3>
      </template>
      <template slot="action">
        <a-button-group>
          <a-button
            @click="handleSet"
            type="primary"
            :disabled="selected.length == 0"
            >Set</a-button
          >
          <a-button
            @click="handleCloseCollective"
            :type="selected.length == 0 ? 'primary' : ''"
            >Done</a-button
          >
        </a-button-group>
      </template>
    </Collective>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import axios from "axios";
import _ from "lodash";
import Collective from "@/components/collective/Collective.vue";
import CollectivePO from "@/mixins/collective/collectivePO";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "DetailPembelianPo",
  mixins: [CurrencyFormat, CollectivePO, GlobalMethod],
  components: {
    Collective,
  },
  props: {
    listPembelian: {},
    informasi: [],
    mode: String,
    isDraftEdited: Boolean,
    tax: String,
    mata_uang: String,
    shipping: Number,
    check_shipping: Boolean,
    id_pp: String,
    kurs: String,
    jenis_anggaran: String,
  },
  data() {
    let pastemax500 = function (e) {
      //do some IE browser checking for e
      e.clipboardData.getData('text/plain').slice(0, 500);
    }
    return {
      editModal: false,
      pastemax500,
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      satuan: [],
      editData: [],
      push: [],
      newLoading: false,
      dataPN: [],
      dataAset: [],
      selectedPN: null,
      selectedPNm: null,
      ppdetillist: [],
      selectedPPdtl: null,
      trigered: {
        used_for: false,
        pn: true,
        cur: false,
        qty_unit: true,
        is_item: "yes",
        percentage: false,
        disc: false,
        tax: false,
        dis_tax_type: false,
        disabledTaxBearer: true,
        enablePPTaxBearer:false,
        optionNominal:true,
      },
      selectedDetail: "",
      selectedDetail2: "",
      isItem: true,
      isAset: null,
      convert_value: 0,
      modalconvert_value: 0,
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      loadingTable: false,
      trigEmptyList: false,
      initialTaxBearer: "1",
      lbl_inv:"",
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
    this.formUpload = this.$form.createForm(this);
  },
  async created() {
    await this.getPN(null);
    await this.getAset(null);
    this.recountingBalance(this.listPembelian, "remove");
  },
  computed: {
    ...mapGetters(["getScreen", "getSatuan", "getAuth","getType_tax", "getStandartFormatDate"]),
    initialData() {
      if (this.listPembelian === undefined || this.listPembelian.length <= 0) {
        return {
          nama_barang: "",
          jumlah: 0,
          satuan: "",
          harga: 0,
        };
      } else {
        return {
          nama_barang: this.listPembelian.nama_barang,
          jumlah: this.listPembelian.jumlah,
          satuan: this.listPembelian.satuan,
          harga: this.listPembelian.harga,
        };
      }
    },
    initialList() {
      let outputList = [];
      if (this.listPembelian.length >= 1) {
        outputList = this.listPembelian;
      }

      return outputList;
    },
    totalSelected() {
      let total = this.selected.reduce(
        (sum, item) => sum + item.values.hargaTotal,
        0
      );
      return total;
    },
    totalPrice() {
      let total = 0;
      this.getCountWeb.forEach((item) => {
        total = total + item.values.hargaTotal;
      });

      return total;
    },
    totalPriceList() {
      let total = 0;
      //console.log("this.getCountList",this.getCountList)
      this.getCountList.forEach((item) => {
        if (item.values.used_for == "4") {
          total = total + item.values.hargaTotal;
        }
      });

      return total;
    },
    totalDiscList() {
      let total = 0;
      this.getCountList.forEach((item) => {
        if (item.values.used_for == "1") {
          total = total + item.values.hargaTotal;
        }
      });

      return total;
    },
    totalShipping() {
      let shipping = 0;
      this.getCountList.forEach((item) => {
        if (item.values.used_for == "3") {
          shipping = shipping + item.values.hargaTotal;
        }
      });
      return shipping;
    },
    grandTotal() {
      return (
        this.totalPrice +
        this.totalPriceList +
        this.nilaiPajak +
        (this.totalShipping > 0 ? parseFloat(this.totalShipping) : 0) -
        this.totalDiscList
      );
    },
    nilaiPajak() {
      let tax = 0;
      this.getCountList.forEach((item) => {
        if (item.values.used_for == "2") {
          if(!(item.values.tax_type && item.values.tax_type.includes('pph'))){
            if (item.values.cur_type == "percentage") {
              tax =
                tax + 
                (parseFloat(item.values.harga) *
                  (this.totalPrice - this.totalDiscList)) /
                  100 ;
            } else {
              tax = tax +  
                parseFloat(item.values.harga);
            }
          }
        }
      });
      return tax;
    },
    initialSatuan() {
      let satuan = [];
      this.getSatuan.forEach((item) => {
        satuan.push(item["id"]);
      });

      return satuan;
    },
    columns() {
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          sorter: (a, b) => a.no - b.no,
          fixed: "left",
        },
        {
          title: "Item/Aset Name",
          dataIndex: "item_name",
          width: 250,
          scopedSlots: { customRender: "itemPN" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Inventaris",
          width: 150,
          align: "center",
          scopedSlots: { customRender: "isinventaris" },
          sorter: (a, b) => a.isinventaris - b.isinventaris,
        },
        {
          title: "PP Detail",
          width: 250,
          scopedSlots: { customRender: "itemPPDtl" },
          sorter: (a, b) => a.pp_nama_barang.length - b.pp_nama_barang.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
        {
          title: "Values",
          dataIndex: "unit_price",
          align: "right",
          key: "hargaTotal",
          width: 150,
        },
        {
          title: "Total Value",
          dataIndex: "amount",
          key: "amount",
          width: 100,
        },
        {
          title: "Note",
          key: "note",
          width: 150,
          scopedSlots: { customRender: "note" },
        },
        {
          title: this.isCollective ? "Check" : "Action",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 110,
          fixed: "right",
        },
      ];
      return kolom;
    },
    getCountWeb() {
      let data = this.listPembelian.filter(
        (item) => item.values.is_item == "yes"
      );

      if (data) {
        this.isItem = true;
        if (data.length > 0) {
          this.isItem = false;
        }
        data.forEach((value, index) => {
          data[index]["item_pn"] = value.values.item_pn;
          data[index]["item_name"] = value.values.nama_barang;
          data[index]["selectedPPdtl"] = data[index]["selectedPPdtl"]
            ? data[index]["selectedPPdtl"]
            : value.values.selectedPPdtl
            ? value.values.selectedPPdtl
            : "";
          data[index]["pp_nama_barang"] = data[index]["pp_nama_barang"]
            ? data[index]["pp_nama_barang"]
            : value.values.pp_nama_barang
            ? value.values.pp_nama_barang
            : "";
          data[index]["pp_kode_anggaran"] = data[index]["pp_kode_anggaran"]
            ? data[index]["pp_kode_anggaran"]
            : value.values.pp_kode_anggaran
            ? value.values.pp_kode_anggaran
            : "";
          data[index]["amount"] = this.formatCurrency(
            this.mata_uang,
            value.values.hargaTotal
          );
          data[index]["quantity"] =
            value.values.jumlah + " " + value.values.satuan;
          data[index]["unit_price"] = this.formatCurrency(
            this.mata_uang,
            value.values.harga
          );
          data[index]["no"] = index + 1;
          data[index]["key"] = "agrid" + (index + 1);
          data[index]["type_item"] = value.values.type_item;
          data[index]["id_po_dtl"] = value.values.id_po_dtl;
        });
      }
      return data;
    },
    getCountList() {
      let data = this.listPembelian.filter(
        (item) => item.values.is_item == "no"
      );
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.values.nama_barang;
          data[index]["unit_price"] = value.values.harga;
          data[index]["key"] =
            (value.values.used_for == "1" ? "bdisc" : "list") + (index + 1);
          data[index]["selectedPPdtl"] = value.values.selectedPPdtl;
        });
      }
      return data;
    },
    getListTax() {
      let data = this.listPembelian.filter(
        (item) => item.values.is_item == "no" && item.values.used_for == "2"
      );
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.values.nama_barang;
          data[index]["unit_price"] = value.values.harga;
          data[index]["key"] = "tax" + (index + 1);
          data[index]["selectedPPdtl"] = value.values.selectedPPdtl;
        });
      }
      return data;
    },
    getListDisc() {
      let data = this.listPembelian.filter(
        (item) => item.values.is_item == "no" && item.values.used_for == "1"
      );
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.values.nama_barang;
          data[index]["unit_price"] = value.values.harga;
          data[index]["key"] = "bdisc" + (index + 1);
          data[index]["selectedPPdtl"] = value.values.selectedPPdtl;
        });
      }
      return data;
    },
    getListUsualShipp() {
      let data = this.listPembelian.filter(
        (item) =>
          item.values.is_item == "no" &&
          (item.values.used_for == "4" || item.values.used_for == "3")
      );
      if (data) {
        data.forEach((value, index) => {
          data[index]["item_name"] = value.values.nama_barang;
          data[index]["unit_price"] = value.values.harga;
          data[index]["key"] = "usualship" + (index + 1);
          data[index]["selectedPPdtl"] = value.values.selectedPPdtl;
        });
      }
      return data;
    },
    roundingValue(){
      let round = 0;
      if (this.mata_uang=="IDR"){
        let tmpTotalAll = (
          this.totalPrice +
          this.totalPriceList +
          this.nilaiPajak +
          (this.totalShipping > 0 ? parseFloat(this.totalShipping) : 0) -
          this.totalDiscList
        );

        round = Math.ceil(tmpTotalAll) - tmpTotalAll;
        if(round > 0.5 && round <=1){
          round = -1 + round;
        }else if(round <= 0.5  && round>0){
          round = 1 * round;
        }else if(round<=0){
          round = 0;
        }

        //memastikan pp detail terdapat value yang dapat dikurangi nilai rounding
        if(round>0){
          let lflag = false;
          this.ppdetillist.forEach((element) => {
            if (
              parseFloat(element.nilai_dtl_pp) > 0 && parseFloat(element.nilai_dtl_pp) > round
            ) {
              lflag = true;
            }
          });

          if (!lflag){
            round = 0;
          }
        }
      }
      return round
    },
    anyPPH() {
      let r = _.filter(this.listPembelian, (item) => item.values.tax_type && item.values.tax_type.indexOf("pph") >= 0);
      return r.length > 0
    }
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("responseConfirmAdd", this.confirmAdd);
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("responseConfirmAdd", this.confirmAdd);
  },
  activated() {
    this.fetchAttribute();
    if(this.jenis_anggaran=="05"){
      this.isAset = true;
    }else{
      this.isAset = false;
    }
  },
  methods: {
    moment,
    convertingqty() {
      let vinput = this.form.getFieldsValue();
      let tot = vinput.harga * parseFloat(this.kurs);
      this.convert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
      this.lbl_inv = tot>=5000000 ? "THIS IS ASET" : "THIS IS NOT ASET";
    },
    convertinghrg(val) {
      // console.log("cek")
      let vinput = this.form.getFieldsValue();
      let tot = 0;
      tot =
        (vinput.jumlah ? vinput.jumlah : 1) *
        (val ? val : vinput.harga) *
        parseFloat(this.kurs);
      if (vinput.is_item == "no") {
        if (vinput.cur_type == "percentage") {
          if (vinput.used_for == "3" || vinput.used_for == "4") {
            tot = ((this.totalPrice * val) / 100) * parseFloat(this.kurs);
          } else {
            tot =
              (((this.totalPrice - this.totalDiscList) * val) / 100) *
              parseFloat(this.kurs);
          }
        }
      }
      let nett = (val ? val : vinput.harga) * parseFloat(this.kurs);
      this.convert_value = this.formatRupiah(isNaN(nett) ? 0 : nett);
      this.lbl_inv = nett>=5000000 ? "THIS IS ASET" : "THIS IS NOT ASET";
    },
    convertingmodalqty(val) {
      let vinput = this.modalForm.getFieldsValue();
      let tot =
        (val ? val : vinput.jumlah) * vinput.harga * parseFloat(this.kurs);
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    convertingmodalhrg(val) {
      let vinput = this.modalForm.getFieldsValue();
      let tot = 0;
      tot =
        (vinput.jumlah ? vinput.jumlah : 1) *
        (val ? val : vinput.harga) *
        parseFloat(this.kurs);
      if (vinput.is_item == "no") {
        if (vinput.cur_type == "percentage") {
          if (vinput.used_for == "3" || vinput.used_for == "4") {
            tot = ((this.totalPrice * val) / 100) * parseFloat(this.kurs);
          } else {
            let tdisc = vinput.used_for == "1" ? 0 : this.totalDiscList;
            tot =
              (((this.totalPrice - tdisc) * val) / 100) * parseFloat(this.kurs);
          }
        }
      }
      let nett = (val ? val : vinput.harga) * parseFloat(this.kurs);
      this.modalconvert_value = this.formatRupiah(isNaN(nett) ? 0 : nett);
      this.lbl_inv = nett>=5000000 ? "THIS IS ASET" : "THIS IS NOT ASET";
    },
    optionchange(val) {
      //console.log(val)
      let vinput = this.modalForm.getFieldsValue();
      let tot = 0;
      tot =
        (vinput.jumlah ? vinput.jumlah : 1) *
        (vinput.harga ? vinput.harga : 0) *
        parseFloat(this.kurs);
      if (vinput.is_item == "no") {
        if (val == "percentage") {
          let totdisc = 0;
          if (
            vinput.used_for == "1" ||
            vinput.used_for == "3" ||
            vinput.used_for == "4"
          ) {
            totdisc = 0;
          }
          tot =
            (((this.totalPrice - totdisc) * vinput.harga) / 100) *
            parseFloat(this.kurs);
        }
      }
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    handleUseFor(val) {
      this.trigered.enablePPTaxBearer=false;
      this.trigered.dis_tax_type = true;
      this.trigered.optionNominal = true;
      if (val.target.value == "1") {
        this.trigered.disc = true;
        this.trigered.dis_tax_type = false;
      } else {
        this.trigered.disc = false;
      }

      if (val.target.value == "2") {
        this.trigered.dis_tax_type = false;
        this.trigered.tax = true;
      }else{
        this.trigered.tax = false;
      }
    },
    preventEnterButton() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.addMainBtn.$children[0].$el.focus();
      });
    },
    preventEnterButtonModal() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.change.$children[0].$el.focus();
      });
    },
    handleOption(val) {
      //console.log(val)
      if (val == "percentage") {
        this.trigered.percentage = true;
      } else {
        this.trigered.percentage = false;
      }

      let vinput = this.form.getFieldsValue();
      let tot = 0;
      tot =
        (vinput.jumlah ? vinput.jumlah : 1) *
        (vinput.harga ? vinput.harga : 0) *
        parseFloat(this.kurs);
      if (vinput.is_item == "no") {
        if (val == "percentage") {
          if (vinput.used_for == "3" || vinput.used_for == "4") {
            tot =
              ((this.totalPrice * vinput.harga) / 100) * parseFloat(this.kurs);
          } else {
            tot =
              (((this.totalPrice - this.totalDiscList) * vinput.harga) / 100) *
              parseFloat(this.kurs);
          }
        }
      }
      this.convert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
    },
    fetchAttribute() {
      let dataParams =
        this.mode == "Edit"
          ? {
              id_pp: this.id_pp,
              id_po: this.informasi.id_po,
            }
          : {
              id_pp: this.id_pp,
            };
      const ppdetil = axios({
        method: "get",
        params: dataParams,
        url: this.$serviceUrl + "pp/nama_item",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return axios
        .all([
          ppdetil.catch((err) => {
            console.log(err);
            return null;
          }),
        ])
        .then((response) => {
          if (response[0] !== undefined) {

            this.ppdetillist = response[0].data.list_nama_item;
            if (this.listPembelian.length > 0) {
              this.recountingBalance(this.listPembelian, "remove");
            }
          } else {
            this.ppdetillist = [];
          }
        })
        .catch((err) => {
          console.log(err);
          // this.pageLoading = false;
        });
    },
    simulation(arr, poin, mode) {
      let result = true;
      if (this.ppdetillist.length > 0) {
        for (let index = 0; index < this.ppdetillist.length; index++) {
          this.ppdetillist[index].temp_nilai_dtl_pp =
            this.ppdetillist[index].nilai_dtl_pp_origin;
        }
      }
      if (arr.length > 0) {
        //menghitung total jumlah item terbaru
        let totalprice = 0;
        arr.forEach((ent) => {
          if (ent.values.is_item == "yes") {
            totalprice += parseFloat(ent.values.hargaTotal);
          }
        });
        //menghitung diskon terbaru
        let totaldisc = 0;
        arr.forEach((ent) => {
          if (ent.values.is_item == "no" && ent.values.used_for == "1") {
            totaldisc +=
              ent.values.cur_type == "currency"
                ? parseFloat(ent.values.hargaTotal)
                : (parseFloat(ent.values.harga) * totalprice) / 100;
          }
          // if (ent.values.is_item == "no" && (ent.values.tax_type && ent.values.tax_type.includes("pph")
          //   && (ent.values.tax_bearer && ent.values.tax_bearer=='1'))) {
          //   totaldisc +=
          //     ent.values.cur_type == "currency"
          //       ? parseFloat(ent.values.hargaTotal)
          //       : (parseFloat(ent.values.harga) * totalprice) / 100;
          // }
        });
        let totalpricedisc = totalprice - totaldisc;
        //short a to z
        arr.sort(function (a, b) {
          var x = a.key.toLowerCase();
          var y = b.key.toLowerCase();
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
        //console.log("short", arr);
        arr.forEach((ment) => {
          let ppdtl = ment.values.selectedPPdtl;
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem == ppdtl) {
              if (ment.values.cur_type == "percentage") {
                let hitung1 =
                  (parseFloat(ment.values.harga) *
                    (ment.values.used_for == "2" && !(ment.values.tax_type && ment.values.tax_type.includes("pph")
                      && (ment.values.tax_bearer && ment.values.tax_bearer=='0'))
                      ? totalpricedisc
                      : totalprice)) /
                  100;
                this.ppdetillist[index].temp_nilai_dtl_pp = (
                  parseFloat(this.ppdetillist[index].temp_nilai_dtl_pp) -
                  hitung1
                ).toString();
                // console.log(
                //   ment.key,
                //   index,
                //   "%kurangi",
                //   ment.values.pp_nama_barang,
                //   hitung1,
                //   this.ppdetillist[index].temp_nilai_dtl_pp,
                //   parseFloat(ment.values.harga),
                //   mode,
                //   totalpricedisc,
                //   "=",
                //   totalprice,
                //   this.totalDiscList
                // );
              } else {
                let hitung2 = parseFloat(ment.values.hargaTotal);
                  this.ppdetillist[index].temp_nilai_dtl_pp = (
                    parseFloat(this.ppdetillist[index].temp_nilai_dtl_pp) -
                    hitung2
                  ).toString();
                // console.log(
                //   ment.key,
                //   index,
                //   "kurangi",
                //   ment.values.pp_nama_barang,
                //   hitung2,
                //   this.ppdetillist[index].temp_nilai_dtl_pp
                // );
              }
            }
          }
          if (ment.values.is_item == "no" && ment.values.used_for == "1") {
            if (ment.values.cur_type == "percentage") {
              let hitung3 = (totalprice * ment.values.harga) / 100;
              this.simulasibagiRataDiscountKeList(
                totalprice,
                hitung3,
                mode == "add" ? arr : this.listPembelian
              );
            } else {
              this.simulasibagiRataDiscountKeList(
                totalprice,
                ment.values.harga,
                mode == "add" ? arr : this.listPembelian
              );
            }
          }
          // if (ment.values.is_item == "no" && (ment.values.tax_type && ment.values.tax_type.includes("pph")
          //   && (ment.values.tax_bearer && ment.values.tax_bearer=='1'))) {
          //   if (ment.values.cur_type == "percentage") {
          //     let hitung3 = (totalprice * ment.values.harga) / 100;
          //     this.simulasibagiRataDiscountKeList(
          //       totalprice,
          //       hitung3,
          //       mode == "add" ? arr : this.listPembelian
          //     );
          //   } else {
          //     this.simulasibagiRataDiscountKeList(
          //       totalprice,
          //       ment.values.harga,
          //       mode == "add" ? arr : this.listPembelian
          //     );
          //   }
          // }
        });

        this.ppdetillist.forEach((element) => {
          if (
            parseFloat(element.temp_nilai_dtl_pp) < 0 &&
            element.id_pp_dtl == poin.selectedPPdtl
          ) {
            result = false;
          }
        });

        let rcount = 0;
        //console.log("rcount", rcount, arr);
        arr.forEach((ment) => {
          if (ment.values.is_item == "yes") {
            rcount = rcount + parseFloat(ment.values.hargaTotal);
          }
          if (ment.values.is_item == "no" && ment.values.used_for == "1") {
            rcount =
              rcount -
              (ment.values.cur_type == "percentage"
                ? (parseFloat(ment.values.harga) * totalprice) / 100
                : parseFloat(ment.values.hargaTotal));
          }
          // if (ment.values.is_item == "no" && (ment.values.tax_type && ment.values.tax_type.includes("pph")
          //   && (ment.values.tax_bearer && ment.values.tax_bearer=='1'))) {
          //   rcount =
          //     rcount -
          //     (ment.values.cur_type == "percentage"
          //       ? (parseFloat(ment.values.harga) * totalprice) / 100
          //       : parseFloat(ment.values.hargaTotal));
          // }
          // if (ment.values.is_item == "no" && ment.values.used_for == "2" && !(ment.values.tax_type && ment.values.tax_type.includes("pph")
          //   && (ment.values.tax_bearer && ment.values.tax_bearer=='1'))) {
          //   rcount =
          //     rcount +
          //     (ment.values.cur_type == "percentage"
          //       ? (parseFloat(ment.values.harga) * totalpricedisc) / 100
          //       : parseFloat(ment.values.hargaTotal));
          // }
          if (
            ment.values.is_item == "no" &&
            ment.values.used_for !== "1" &&
            ment.values.used_for !== "2"
          ) {
            rcount =
              rcount +
              (ment.values.cur_type == "percentage"
                ? (parseFloat(ment.values.harga) * totalprice) / 100
                : parseFloat(ment.values.hargaTotal));
          }
          //console.log("result", rcount, ment.values.harga, totalpricedisc);
          if (rcount < 0) {
            result = false;
          }
        });
      }
      return result;
    },
    recountingBalance(arr, mode) {
      if (this.ppdetillist.length > 0) {
        for (let index = 0; index < this.ppdetillist.length; index++) {
          this.ppdetillist[index].nilai_dtl_pp =
            this.ppdetillist[index].nilai_dtl_pp_origin;
        }
      }
      if (arr.length > 0) {
        //menghitung total jumlah item terbaru
        let totalprice = 0;
        arr.forEach((ent) => {
          if (ent.values.is_item == "yes") {
            totalprice += parseFloat(ent.values.hargaTotal);
          }
        });
        //menghitung diskon terbaru
        let totaldisc = 0;
        arr.forEach((ent) => {
          if (ent.values.is_item == "no" && ent.values.used_for == "1") {
            totaldisc +=
              ent.values.cur_type == "currency"
                ? parseFloat(ent.values.hargaTotal)
                : (parseFloat(ent.values.harga) * totalprice) / 100;
          }
          // if (ent.values.is_item == "no" && ent.values.tax_type && ent.values.tax_type.includes("pph")
          //   && (ent.values.tax_bearer && ent.values.tax_bearer=='1')) {
          //   totaldisc +=
          //     ent.values.cur_type == "currency"
          //       ? parseFloat(ent.values.hargaTotal)
          //       : (parseFloat(ent.values.harga) * totalprice) / 100;
          // }
        });
        let totalpricedisc = totalprice - totaldisc;
        //short a to z
        arr.sort(function (a, b) {
          var x = a.key;
          var y = b.key;
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
        //console.log("short", arr);
        arr.forEach((ment) => {
          let ppdtl = ment.values.selectedPPdtl;
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem == ppdtl) {
              if (ment.values.cur_type == "percentage") {
                // let hitung1 =
                //   (parseFloat(ment.values.harga) *
                //     (ment.values.used_for == "2" && (!ment.values.tax_type.includes("pph") && (ment.values.tax_bearer && ment.values.tax_bearer=='1'))
                //       ? totalpricedisc
                //       : totalprice)) /
                //   100;
                let hitung1 =
                  (parseFloat(ment.values.harga) *
                    (ment.values.used_for == "2"
                      ? totalpricedisc
                      : totalprice)) /
                  100;
                this.ppdetillist[index].nilai_dtl_pp = (
                  parseFloat(this.ppdetillist[index].nilai_dtl_pp) - hitung1
                ).toString();
                // console.log(
                //   ment.key,
                //   index,
                //   "%kurangi",
                //   ment.values.pp_nama_barang,
                //   hitung1,
                //   this.ppdetillist[index].nilai_dtl_pp,
                //   parseFloat(ment.values.harga),
                //   mode,
                //   totalpricedisc,
                //   "=",
                //   totalprice,
                //   this.totalDiscList
                // );
              } else {
                let hitung2 = parseFloat(ment.values.hargaTotal);
                this.ppdetillist[index].nilai_dtl_pp = (
                  parseFloat(this.ppdetillist[index].nilai_dtl_pp) - hitung2
                ).toString();
                // console.log(
                //   ment.key,
                //   index,
                //   "kurangi",
                //   ment.values.pp_nama_barang,
                //   hitung2,
                //   this.ppdetillist[index].nilai_dtl_pp
                // );
              }
            }
          }
          if (ment.values.is_item == "no" && ment.values.used_for == "1") {
            if (ment.values.cur_type == "percentage") {
              let hitung3 = (totalprice * ment.values.harga) / 100;
              this.bagiRataDiscountKeList(
                totalprice,
                hitung3,
                mode == "add" ? arr : this.listPembelian
              );
            } else {
              this.bagiRataDiscountKeList(
                totalprice,
                ment.values.harga,
                mode == "add" ? arr : this.listPembelian
              );
            }
          }
          // if (ment.values.is_item == "no" && ment.values.tax_type && ment.values.tax_type.includes("pph")
          //   && (ment.values.tax_bearer && ment.values.tax_bearer=='1')) {
          //   if (ment.values.cur_type == "percentage") {
          //     let hitung3 = (totalprice * ment.values.harga) / 100;
          //     this.bagiRataDiscountKeList(
          //       totalprice,
          //       hitung3,
          //       mode == "add" ? arr : this.listPembelian
          //     );
          //   } else {
          //     this.bagiRataDiscountKeList(
          //       totalprice,
          //       ment.values.harga,
          //       mode == "add" ? arr : this.listPembelian
          //     );
          //   }
          // }
        });

        for (let index = 0; index < this.listPembelian.length; index++) {
          const element = this.listPembelian[index];
          if ("percentage" == element.values.cur_type) {
            // if (element.values.used_for == "2" && !element.values.tax_type.includes("pph")
            //   && (element.values.tax_bearer && element.values.tax_bearer=='1')) {
            if (element.values.used_for == "2") {
              this.listPembelian[index].values.hargaTotal =
                (totalpricedisc * this.listPembelian[index].values.harga) / 100;
            } else {
              this.listPembelian[index].values.hargaTotal =
                (totalprice * this.listPembelian[index].values.harga) / 100;
            }
          }
        }

        //menghitung pajak, shipping dan etc
        // arr.forEach(ment => {
        //   let ppdtl=ment.values.selectedPPdtl
        //   for (let index = 0; index < this.ppdetillist.length; index++) {
        //     const elem = this.ppdetillist[index].id_pp_dtl;
        //     if (elem==ppdtl && ment.values.used_for=="2"){
        //       if(ment.values.cur_type=="percentage"){
        //         this.ppdetillist[index].nilai_dtl_pp = (parseFloat(this.ppdetillist[index].nilai_dtl_pp) -
        //           (parseFloat(ment.values.harga)*(totalprice)/100)).toString()
        //       }else{
        //         this.ppdetillist[index].nilai_dtl_pp = (parseFloat(this.ppdetillist[index].nilai_dtl_pp) -
        //           parseFloat(ment.values.hargaTotal)).toString()
        //       }
        //     }
        //   }
        // });
      }
    },
    simulasibagiRataDiscountKeList(total, val, arr) {
      //console.log("bagiRataDiscountKeList",total,val,arr)
      arr.forEach((ment) => {
        let ppdtl = ment.values.selectedPPdtl;
        for (let index = 0; index < this.ppdetillist.length; index++) {
          const elem = this.ppdetillist[index].id_pp_dtl;
          if (elem == ppdtl && ment.values.is_item == "yes") {
            this.ppdetillist[index].temp_nilai_dtl_pp =
              parseFloat(this.ppdetillist[index].temp_nilai_dtl_pp) +
              (parseFloat(ment.values.hargaTotal) / total) * val;
            // console.log(
            //   ment.key,
            //   index,
            //   "     - = ",
            //   this.ppdetillist[index].nilai_dtl_pp_origin,
            //   ment.values.hargaTotal,
            //   total,
            //   val,
            //   (parseFloat(ment.values.hargaTotal) / total) * val,
            //   this.ppdetillist[index].temp_nilai_dtl_pp
            // );
          }
        }
      });
    },
    bagiRataDiscountKeList(total, val, arr) {
      //console.log("bagiRataDiscountKeList",total,val,arr)
      arr.forEach((ment) => {
        let ppdtl = ment.values.selectedPPdtl;
        for (let index = 0; index < this.ppdetillist.length; index++) {
          const elem = this.ppdetillist[index].id_pp_dtl;
          if (elem == ppdtl && ment.values.is_item == "yes") {
            this.ppdetillist[index].nilai_dtl_pp =
              parseFloat(this.ppdetillist[index].nilai_dtl_pp) +
              (parseFloat(ment.values.hargaTotal) / total) * val;
            // console.log(
            //   ment.key,
            //   index,
            //   "     - = ",
            //   this.ppdetillist[index].nilai_dtl_pp_origin,
            //   ment.values.hargaTotal,
            //   total,
            //   val,
            //   (parseFloat(ment.values.hargaTotal) / total) * val,
            //   this.ppdetillist[index].nilai_dtl_pp
            // );
          }
        }
      });
    },
    kurangRataDiscountKeList(total, val) {
      this.getCountWeb.forEach((ment) => {
        let ppdtl = ment.values.selectedPPdtl;
        for (let index = 0; index < this.ppdetillist.length; index++) {
          const elem = this.ppdetillist[index].id_pp_dtl;
          if (elem == ppdtl && ment.values.used_for == null) {
            // console.log(
            //   "kurangRataDiscountKeList",
            //   this.ppdetillist[index].nilai_dtl_pp
            // );
            //this.ppdetillist[index].nilai_dtl_pp = parseFloat(this.ppdetillist[index].nilai_dtl_pp) - hasil
            this.ppdetillist[index].nilai_dtl_pp =
              parseFloat(this.ppdetillist[index].nilai_dtl_pp) -
              (parseFloat(ment.values.hargaTotal) * val) / total;
            break;
          }
        }
      });
    },
    handleis_item(val) {
      if (val.target.value == "no") {
        this.trigered.is_item = "no";
        this.trigered.used_for = true;
        this.trigered.pn = false;
        this.trigered.cur = true;
        this.trigered.percentage = false;
        this.trigered.qty_unit = false;
        this.push = [];
        this.isAset = false;
        this.trigered.tax = "yes";
        this.trigered.disc = false;
      } else {
        this.trigered.is_item = "yes";
        this.trigered.used_for = false;
        this.trigered.pn = true;
        this.trigered.cur = false;
        this.trigered.percentage = false;
        this.trigered.qty_unit = true;
        this.trigered.tax = "no";
      }
      this.convert_value = 0;
    },
    handleis_aset(val) {
      if (val.target.value=="yes"){
        this.isAset = true;
      }else{
        this.isAset = false;
      }

      this.selectedPN = null;
      this.form.setFieldsValue({
        nama_barang: "",
      });
    },
    getPN(params) {
      axios({
        method: "get",
        url: this.$serviceUrl + "po/assistPN",
        params: {
          filterString: params ? params : "",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.dataPN = response.data.listPN;
        })
        .catch((err) => {
          console.log(err);
          this.displayMessage("error-aktif-project");
        });
    },
    getAset(params) {
      axios({
        method: "get",
        url: this.$serviceUrl + "po/asetPN",
        params: {
          filterString: params ? params : "",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.dataAset = response.data.listPN;
        })
        .catch((err) => {
          console.log(err);
          this.displayMessage("error-aktif-project");
        });
    },
    handleppdtl() {
      // const filter = _.filter(this.ppdetillistemp, (item) =>
      //   item.nama_barang.toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
      //   item.kode_anggaran.toLowerCase().indexOf(value.toLowerCase()) >= 0
      // );
      // if (!this.editModal) {
      //   if (filter.length === 0) {
      //     //this.selectedPN = "";
      //     this.form.setFieldsValue({
      //       nama_barang: "",
      //     });
      //   } else {
      //     this.selectedPN = filter[0].item_pn;
      //     this.form.setFieldsValue({
      //       nama_barang: filter[0].item_nm,
      //     });
      //   }
      // } else {
      //   if (filter.length === 0) {
      //    // this.selectedPNm = "";
      //     this.modalForm.setFieldsValue({
      //       nama_barang: "",
      //     });
      //   } else {
      //     this.selectedPNm = filter[0].item_pn;
      //     this.modalForm.setFieldsValue({
      //       nama_barang: filter[0].item_nm,
      //     });
      //   }
      // }
    },
    handlePN(value) {
      const filter = _.filter(this.dataPN, (item) => {
        if (item.item_pn === (value ? value.item_pn : null)) {
          return item;
        }
      });
      if (!this.editModal) {
        if (filter.length === 0) {
          //this.selectedPN = "";
          this.form.setFieldsValue({
            nama_barang: "",
          });
        } else {
          this.selectedPN = filter[0].item_pn;
          this.form.setFieldsValue({
            nama_barang: filter[0].item_nm,
          });
        }
      } else {
        if (filter.length === 0) {
          // this.selectedPNm = "";
          this.modalForm.setFieldsValue({
            nama_barang: "",
          });
        } else {
          this.selectedPNm = filter[0].item_pn;
          this.modalForm.setFieldsValue({
            nama_barang: filter[0].item_nm,
          });
        }
      }
    },
    handleAset(value) {
      const filter = _.filter(this.dataAset, (item) => {
        if (item.aset_pn === (value ? value.aset_pn : null)) {
          return item;
        }
      });
      if (!this.editModal) {
        if (filter.length === 0) {
          //this.selectedPN = "";
          this.form.setFieldsValue({
            nama_barang: "",
          });
        } else {
          this.selectedPN = filter[0].aset_pn;
          this.form.setFieldsValue({
            nama_barang: filter[0].aset_nm,
          });
        }
      } else {
        if (filter.length === 0) {
          // this.selectedPNm = "";
          this.modalForm.setFieldsValue({
            nama_barang: "",
          });
        } else {
          this.selectedPNm = filter[0].aset_pn;
          this.modalForm.setFieldsValue({
            nama_barang: filter[0].aset_nm,
          });
        }
      }
    },
    handleSatuan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleRef() {
      if (this.listPembelian.length <= 0) {
        this.displayMessage("form-moreData");
      } else {
        // Event.$emit("poData", { estimated_value: this.totalPrice });

        //regenerate ulang harga total untuk memutakhirkan percentage harga terakhir
        for (let index = 0; index < this.listPembelian.length; index++) {
          if (this.listPembelian[index].values.cur_type == "percentage") {
            if (this.listPembelian[index].values.used_for == "1") {
              this.listPembelian[index].values.hargaTotal =
                (this.totalPrice *
                  parseFloat(this.listPembelian[index].values.harga)) /
                100;
            } else {
              this.listPembelian[index].values.hargaTotal =
                ((this.totalPrice -
                  (this.listPembelian[index].values.used_for == "2"
                    ? this.totalDiscList
                    : 0)) *
                  parseFloat(this.listPembelian[index].values.harga)) /
                100;
            }
          }
        }


        //get pp detail untuk pengambilan nilai rounding
        let ppdtl = null;
        if(this.mata_uang=="IDR"){
          for (let index = 0; index < this.ppdetillist.length; index++) {
            if (parseFloat(this.ppdetillist[index].nilai_dtl_pp) >= this.roundingValue) {
              ppdtl = this.ppdetillist[index].id_pp_dtl;
              break;
            }
          }
        }


        Event.$emit("poData", {
          detailBeli: this.listPembelian,
          emptyValidator: this.getCountWeb.length,
          grandTotal : this.grandTotal,
          rounding : { value : this.roundingValue, ppdtl : ppdtl},
        });
      }
    },
    handleNewItem() {
      if (this.push.length > 0) {
        if (this.listPembelian.length > 0) {
          this.$confirm({
            title: "Are you sure want to replace an Exist data?",
            okText: "Yes",
            cancelText: "No",
            onOk() {
              Event.$emit("responseConfirmAdd", true);
            },
            onCancel() {},
          });
        } else {
          this.processNewItem();
        }
      } else {
        this.processNewItem();
      }
    },
    processNewItem() {
      this.newLoading = true;
      //console.log("test")
      if (this.push.length > 0) {
        this.formUpload.validateFields((err, val) => {
          if (err) {
            this.newLoading = false;
            return;
          }
          let formData = new FormData();
          formData.append("file_upload", val.file_transfer.file);
          
          if (this.isObject(this.selectedPN)) {
            this.selectedPN = this.selectedPN.item_pn_concat;
          }
          formData.append("item_pn", this.selectedPN ? this.selectedPN : "");

          axios({
            method: "post",
            url: this.$serviceUrl + "po/upload_po",
            processData: false,
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
              "Content-Type": "multipart/form-data",
            },
          })
            .then((response) => {
              if (this.trigEmptyList) {
                Event.$emit("emptylistPembelian", true);
                this.trigEmptyList = false;
              }

              let data = response.data.param;
              data.forEach((values, index) => {
                values.hargaTotal = values.jumlah * values.harga;
                values.key = index + 1;
                values.is_item = "yes";
                values.used_for = null;
                values.cur_type = null;
                values.type_item = "0"; //paten ke item
                values.jumlah_diterima = "0";
                values.used_for = "0";
                values.isinventaris = values.harga >= 5000000 ? "0" : "1";
                Event.$emit("listPembelian", {
                  values,
                });
              });

              this.form.resetFields();
              this.selectedPN = undefined;

              this.displayMessage("success-add");
              this.newLoading = false;
              this.push = [];
              this.resetForm();
            })
            .catch((err) => {
              this.newLoading = false;
              let responses = Object.assign({}, err.response);
              if (responses.data) {
                this.displayMessageValue("error-other", responses.data.message);
              } else {
                this.displayMessageValue("error", responses);
              }
              console.log(err);
            });
        });
      } else {
        this.form.validateFields(async (err, values) => {
          if (err) {
            this.newLoading = false;
            this.displayMessage("form-warning");
            return;
          }

          if (values.is_item == "no") {
            if (
              values.cur_type == "percentage" &&
              (this.getCountWeb.length == undefined ||
                this.getCountWeb.length == 0)
            ) {
              this.newLoading = false;
              this.displayMessage("empty-phurcaselist");
              return;
            }
          }

          //validasi value entri
          let plafon = 0;
          let pp_nama_barang = "";
          let pp_kode_anggaran = "";
          let vmsk = 0;
          if (values.is_item == "yes") {
            vmsk = values.jumlah * values.harga;
          } else {
            //console.log(values.harga, this.totalPrice, this.totalDiscList);
            vmsk =
              values.cur_type == "percentage"
                ? (values.harga * (this.totalPrice - this.totalDiscList)) / 100
                : values.harga;
          }
          if (values.used_for == "1") {
            plafon = this.totalPrice;
          } else if (values.tax_type && values.tax_type.includes("pph")){
            plafon = this.totalPrice;
          }else {
            this.ppdetillist.forEach((element) => {
              if (element.id_pp_dtl == values.selectedPPdtl) {
                plafon = parseFloat(element.nilai_dtl_pp);
                pp_nama_barang = element.nama_barang;
                pp_kode_anggaran = element.kode_anggaran;
              }
            });
          }

          //perilaku pajak jika PPH dkk disamakan dengan diskon 
          if(values.used_for == "2" && (values.tax_type && values.tax_type.includes("pph"))){
            plafon = this.totalPrice;
          }

          //validasi pajak : tidak boleh lebih dari total
          if (
            values.used_for == "2" && !(values.tax_type && values.tax_type.includes("pph")) &&
            (vmsk > this.totalPrice - this.totalDiscList || vmsk > plafon)
          ) {
            this.newLoading = false;
            this.displayMessageValue("basic-error","Tax value cannot exceed 100% of PO value");
            return;
          }
          //validasi discount : tidak boleh lebih dari total
          if (
            values.used_for == "1" &&
            vmsk > this.totalPrice - this.totalDiscList
          ) {
            this.newLoading = false;
            this.displayMessageValue("basic-error","Discount value cannot exceed 100% of PO value");
            return;
          }
          //validasi PPH series : tidak boleh lebih dari total
          if (
            values.used_for == "2" && (values.tax_type && values.tax_type.includes("pph")) &&
            vmsk > this.totalPrice - this.totalDiscList
          ) {
            this.newLoading = false;
            this.displayMessageValue("basic-error","PPH Series value cannot exceed 100% of PO value");
            return;
          }
          //validasi selain pajak : tidak boleh lebih dari plafon
          // console.log(
          //   "validasi",
          //   vmsk,
          //   plafon,
          //   values.used_for !== "1" || values.used_for == null,
          //   vmsk < 0
          // );
          if (
            (vmsk > plafon &&
              (values.used_for !== "1" || values.used_for == null)) ||
            (values.used_for == "1" && this.totalPrice - vmsk < 0) ||
            (values.used_for == "2" && (values.tax_type && values.tax_type.includes("pph")) && this.totalPrice - vmsk < 0)
          ) {
            this.newLoading = false;
            this.displayMessage("grather-remaining");
            return;
          }

          if (this.isObject(this.selectedPN)) {
            this.selectedPN = this.selectedPN.item_pn_concat;
          }

          values.item_pn = this.selectedPN ? this.selectedPN : "";
          if (values.item_pn == undefined) {
            values.item_pn = null;
          }
          if (values.cur_type == undefined) {
            values.cur_type = null;
          }
          if (values.used_for == undefined) {
            values.used_for = "0";
          }
          let findName = null;
          
          if (values.used_for !== "1") {
            if(values.used_for == "2" && values.tax_type!="ppn" && values.tax_type!="bea_masuk"){
                findName = _.filter(
                this.listPembelian,
                (obj) =>
                  obj.used_for !== "1" &&
                  obj.item_name &&
                  obj.item_name.toLowerCase() == values.nama_barang.toLowerCase()
              );
            }else{
              findName = _.filter(
                this.listPembelian,
                (obj) =>
                  obj.selectedPPdtl &&
                  obj.selectedPPdtl.toLowerCase() ==
                    values.selectedPPdtl.toLowerCase() &&
                  obj.item_name &&
                  obj.item_name.toLowerCase() == values.nama_barang.toLowerCase()
              );
            }
          } else {
            if (values.tax_type && values.tax_type.includes("pph")){
              findName = _.filter(
                this.getListTax,
                (obj) =>
                  obj.item_name &&
                  obj.item_name.toLowerCase() == values.nama_barang.toLowerCase() &&
                  obj.values.tax_type &&
                  obj.values.tax_type == values.tax_type
              );
            }else{
              findName = _.filter(
                this.getListDisc,
                (obj) =>
                  obj.item_name &&
                  obj.item_name.toLowerCase() == values.nama_barang.toLowerCase()
              );
            }
          }
          
          if (findName && findName.length > 0) {
            this.displayMessage("form-duplicate");
            this.newLoading = false;
            return;
          } else {
            values.pp_nama_barang = pp_nama_barang;
            values.pp_kode_anggaran = pp_kode_anggaran;
            let hargaTotal = 0;
            if (values.is_item == "yes") {
              hargaTotal = values.jumlah * values.harga;
            } else {
              let valh = values.harga;
              hargaTotal =
                values.cur_type == "percentage"
                  ? (valh *
                      ((this.totalPrice
                        ? values.used_for == "1" ||
                          values.used_for == "3" ||
                          values.used_for == "4"
                          ? this.totalPrice + this.totalDiscList
                          : this.totalPrice
                        : 0) -
                        (this.totalDiscList ? this.totalDiscList : 0))) /
                    100
                  : valh;
            }
            values.hargaTotal = hargaTotal;
            values.type_item = values.is_aset=="yes" ? "1" : "0";
            values.jumlah_diterima = "0";
            //jika diatas lima juta diakui sebagai inventaris
            values.isinventaris = values.harga>=5000000? "0":"1";

            let isthis = [
              ...this.listPembelian,
              JSON.parse(JSON.stringify({ key: "other", values })),
            ];
            let poin = values;

            if (this.simulation(isthis, poin, "add") == false) {
              this.displayMessage("grather-remaining");
              this.newLoading = false;
              return;
            }

            let formData = new FormData();
            Object.keys(values).forEach((key) => {
              if(key=='selectedPPdtl'){
                formData.append('id_pp_dtl', values[key]);
              }else{
                formData.append(key, values[key]);
                if(key=='hargaTotal'){
                  formData.append('unit_price', values[key]);
                }
              }
            });

            Object.keys(this.informasi).forEach((key) => {
              if(key=='dokumen'){
                if(this.informasi[key][0]){
                  formData.append(this.informasi[key][0]=='COC'?'coc': (this.informasi[key][0]=='CPD' ? 'cpd' :'test_report'), this.informasi[key][0]=='COC'?'1':(this.informasi[key][0]=='TR'?'1': (this.informasi[key][0]=='CPD'?'1':'0')));
                }
                if(this.informasi[key][1]){
                  formData.append(this.informasi[key][1]=='COC'?'coc': (this.informasi[key][1]=='CPD' ? 'cpd' :'test_report'), this.informasi[key][1]=='COC'?'1':(this.informasi[key][1]=='TR'?'1': (this.informasi[key][1]=='CPD'?'1':'0')));
                }
                if(this.informasi[key][2]){
                  formData.append(this.informasi[key][2]=='COC'?'coc': (this.informasi[key][2]=='CPD' ? 'cpd' :'test_report'), this.informasi[key][2]=='COC'?'1':(this.informasi[key][2]=='TR'?'1': (this.informasi[key][2]=='CPD'?'1':'0')));
                }
              }else if(key=='tgl_buat'){
                formData.append('tgl_po', moment(this.informasi[key]).format(this.getStandartFormatDate));
              }else{
                formData.append(key, this.informasi[key]);
              }
            });

            if(this.isDraftEdited || (!this.id && this.mode!='Edit')){
              if(values.is_item=='no'){
                formData.append('id_po', this.informasi.id_po);
              }

              await this.asyncAxiosPost("po/dtl_draft", "formdata", this.getAuth, formData)
              .then(async (response) => {
                  values['id_po_dtl'] =  response.id_po_dtl
              })
              .catch((err) => {
                console.log(err);
                this.newLoading = false;
                return
              });
            }



            Event.$emit("updateList", this.listPembelian);
            Event.$emit("listPembelian", {
              key: "other",
              values: values,
            });
            this.form.resetFields();
            this.trigered.used_for = false;
            this.trigered.qty_unit = true;
            this.trigered.is_item = "yes";
            this.trigered.cur = false;
            this.selectedPN = undefined;
            this.trigered.pn = true;
            this.trigered.disc = false;
            this.convert_value = 0;
            //this.isAset = false;
            if(this.jenis_anggaran=="05"){
              this.isAset = true;
            }else{
              this.isAset = false;
            }
            this.displayMessage("success-add");
            this.newLoading = false;
            this.resetForm();
          }
        });
      }
    },
    confirmAdd() {
      this.trigEmptyList = true;
      this.processNewItem();
    },
    handleRemove(item) {
      // console.log(this.listPembelian, item);
      const newPush = this.listPembelian.filter(
        (valu) =>
          valu.item_name.concat(
            valu.values.selectedPPdtl
              ? valu.values.selectedPPdtl
              : valu.values.used_for
          , valu.values.used_for) !==
          item.nama_barang.concat(
            item.selectedPPdtl ? item.selectedPPdtl : item.used_for
          , item.used_for)
      );

      if (newPush.length > 0) {
        let nextpush = newPush.filter((valu) => valu.values.is_item == "yes");
        let discpush = newPush.filter(
          (valu) => valu.values.is_item == "no" && valu.values.used_for == "1"
        );
        let pphpush = newPush.filter(
          //(valu) => valu.values.is_item == "no" && valu.values.used_for == "2" && (valu.values.tax_type && valu.values.tax_type.includes("pph"))
          (valu) => valu.values.is_item == "no" && valu.values.used_for == "2"
        );
        if (nextpush.length == 0 && discpush.length > 0) {
          this.displayMessageValue(
            "error-other",
            "Purchase List Can't be empty, please delete all discount!"
          );
          this.newLoading = false;
          return;
        }
        if (nextpush.length == 0 && pphpush.length > 0) {
          this.displayMessageValue(
            "error-other",
            "Purchase List Can't be empty, please delete all PPH Series!"
          );
          this.newLoading = false;
          return;
        }
      }

      if (!this.simulation(newPush, "add")) {
        this.displayMessage("grather-remaining");
        this.newLoading = false;
        return;
      }

      let trig = false;
      // if (item.used_for == "1" || (item.tax_type && item.tax_type.includes("pph"))) {
      if (item.used_for == "1") {
        for (let index = 0; index < this.ppdetillist.length; index++) {
          this.ppdetillist[index].temp_remove_val =
            this.ppdetillist[index].nilai_dtl_pp;
        }
        this.getCountWeb.forEach((ment) => {
          let ppdtl = ment.values.selectedPPdtl;
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem == ppdtl) {
              let bsaran =
                (ment.values.hargaTotal / this.totalPrice) * item.hargaTotal;
              //console.log("-",ment.values.hargaTotal,this.totalPrice,item.hargaTotal)
              //console.log(this.ppdetillist[index].temp_remove_val,bsaran,this.ppdetillist[index].temp_remove_val-bsaran)
              if ((parseFloat(this.ppdetillist[index].temp_remove_val)).toFixed(2) - bsaran.toFixed(2) < 0) {
                trig = true;
                return;
              }
              this.ppdetillist[index].temp_remove_val =
                this.ppdetillist[index].temp_remove_val - bsaran;
            }
          }
        });
      }
      if (trig) {
        this.displayMessage("grather-remaining");
        return;
      } else {
        this.confirmMessageValue("confirm-delete", item, null);
      }
    },
    handleRemoveList(file) {
      const index = this.push.indexOf(file);
      const newFileList = this.push.slice();
      newFileList.splice(index, 1);
      this.push = newFileList;
    },
    delete(val) {
      if(this.isDraftEdited){
        this.asyncAxiosDelete(
          "po/dtl_draft",
          "application/json",
          this.getAuth,
          { id_po_dtl: val.id_po_dtl }
        )
        .then((response) => {
          this.displayMessageValue("success-other", response.message);
          const existdata = this.listPembelian.filter(
            (item) =>
              item.item_name.concat(item.values.selectedPPdtl) !==
              val.nama_barang.concat(val.selectedPPdtl)
          );
          if(existdata.length == 0){
            this.$router.push({
              name: "po",
              params: {},
            });
            return
          }
        })
        .catch((err) => {
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
          return;
        });
      }

      const newPush = this.listPembelian.filter(
        (item) =>
          item.item_name.concat(item.values.selectedPPdtl) !==
          val.nama_barang.concat(val.selectedPPdtl)
      );
      this.modalForm.resetFields();
      this.$nextTick(function () {
        this.form.setFieldsValue({
          is_item: 'yes',
        });
      });
      this.trigered.is_item = "yes";
      this.trigered.used_for = false;
      this.trigered.qty_unit = true;
      this.trigered.cur = false;
      this.selectedPN = undefined;
      this.trigered.pn = true;
      this.trigered.disc = false;
      this.convert_value = 0;

      Event.$emit("updateList", newPush);
    },
    handleEditModal(item) {
      // console.log(item)
      this.modalForm.resetFields();
      this.editData = item;
      this.editModal = !this.editModal;
      this.trigered.is_item = item.values.is_item;
      this.trigered.disc = item.values.used_for == "1" ? true : false;
      this.trigered.tax = item.values.used_for == "2" ? true : false;
      if(item.values.tax_type)
        this.taxTypeChange(item.values.tax_type);
      if(item.selectedPPdtl)
        this.handleDetail2(item.selectedPPdtl);
        //console.log(item.values)
        if(item.values.tax_bearer && item.values.tax_bearer=='0' && item.values.used_for!='1'){
          this.trigered.enablePPTaxBearer=true;
          this.trigered.dis_tax_type = true;
        }else{
          if(item.values.used_for=='3' || item.values.used_for=='4'){
            this.trigered.enablePPTaxBearer=true;
            this.trigered.dis_tax_type = true;
          }else{
            this.trigered.enablePPTaxBearer=false;
            this.trigered.dis_tax_type = false;
          }
        }
      //console.log(this.trigered.dis_tax_type)
      let tot = 0;
      tot =
        (item.values.jumlah ? item.values.jumlah : 1) *
        (item.values.harga ? item.values.harga : 0) *
        parseFloat(this.kurs);
      if (item.values.is_item == "no") {
        if (item.values.cur_type == "percentage") {
          let tdisc =
            item.values.used_for == "1" ||
            item.values.used_for == "3" ||
            item.values.used_for == "4"
              ? 0
              : this.totalDiscList;
          tot =
            (((this.totalPrice - tdisc) * item.values.harga) / 100) *
            parseFloat(this.kurs);
        }
      }
      this.modalconvert_value = this.formatRupiah(isNaN(tot) ? 0 : tot);
      let nett = item.values.harga * parseFloat(this.kurs);
      this.lbl_inv = nett>=5000000 ? "THIS IS ASET" : "THIS IS NOT ASET";

      this.selectedPNm = item.item_pn;

      if (item.values.used_for == null) {
        this.kurangRataDiscountKeList(this.totalPrice, this.totalDiscList);
      }
      if (this.ppdetillist.length > 0) {
        for (let index = 0; index < this.ppdetillist.length; index++) {
          const elem = this.ppdetillist[index].id_pp_dtl;
          if (elem == item.selectedPPdtl) {
            // console.log(
            //   parseFloat(this.ppdetillist[index].nilai_dtl_pp),
            //   item.values.hargaTotal
            // );
            this.ppdetillist[index].nilai_dtl_pp =
              parseFloat(this.ppdetillist[index].nilai_dtl_pp) +
              item.values.hargaTotal;
          }
        }
      }
    },
    handleClose() {
      this.recountingBalance(this.listPembelian, "remove");
      this.resetForm();
    },
    resetForm() {
      this.form.resetFields();
      this.selectedPN = null;
      this.trigered.cur = false;
      this.trigered.disc = false;
      this.trigered.is_item = "yes";
      this.trigered.percentage = false;
      this.trigered.pn = true;
      this.trigered.qty_unit = true;
      this.trigered.used_for = false;
      this.trigered.optionNominal = true;
      this.lbl_inv = "";
    },
    handleModalEdit(id_key) {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (values.used_for==undefined)
          values.used_for="0";
        
        if (values.is_item == "no") {
          if (
            values.cur_type == "percentage" &&
            (this.getCountWeb.length == undefined ||
              this.getCountWeb.length == 0)
          ) {
            this.newLoading = false;
            this.displayMessage("empty-phurcaselist");
            return;
          }
        }
        

        if (this.isObject(this.selectedPNm)) {
          this.selectedPNm = this.selectedPNm.item_pn_concat;
        }

        let findNames = null;
        if (values.used_for == "1") {
          findNames = _.filter(
            this.listPembelian,
            (obj) =>
              obj.values.used_for &&
              obj.values.used_for.toLowerCase() ==
                values.used_for.toLowerCase() &&
              obj.item_name &&
              obj.item_name.toLowerCase() == values.nama_barang.toLowerCase()
          );
        } else {
          findNames = _.filter(
            this.listPembelian,
            (obj) =>
              obj.selectedPPdtl &&
              obj.selectedPPdtl ==
                values.selectedPPdtl &&
              obj.item_name &&
              obj.item_name.toLowerCase() == values.nama_barang.toLowerCase()
          );
        }

        if (findNames.length > 0 && findNames[0].key !== id_key) {
          this.displayMessage("form-duplicate");
          return;
        } else {
          //validasi revisi tidak boleh kurang dari jumlah diterima
          if(this.mode=="Edit" && values.jumlah<=this.editData.values.jumlah_diterima){
            this.displayMessageValue("error-other", "QTY must be greater than QTY receive("+this.editData.values.jumlah_diterima+")!");
            return;
          }
          //validasi value entri
          let plafon = 0;
          let pp_nama_barang = "";
          let pp_kode_anggaran = "";
          let vmsk = 0;
          if (values.is_item == "yes") {
            vmsk = values.jumlah * values.harga;
          } else {
            vmsk =
              values.cur_type == "percentage"
                ? (values.harga * this.totalPrice) / 100
                : values.harga;
          }

          let dataExist = {};
          if (values.used_for == "1") {
            plafon = this.grandTotal;
          } else {
            this.ppdetillist.forEach((element) => {
              if (element.id_pp_dtl == values.selectedPPdtl) {
                plafon = parseFloat(element.nilai_dtl_pp);
                pp_nama_barang = element.nama_barang;
                pp_kode_anggaran = element.kode_anggaran;
              }
            });
          }
          //get discount exist
          dataExist = _.filter(
            this.listPembelian,
            (obj) => obj.key && obj.key.toLowerCase() == id_key.toLowerCase()
          );

          let discExist = 0;
          if (dataExist) {
            discExist = dataExist.values.hargaTotal;
          }

          //validasi pajak : tidak boleh lebih dari total
          if (
            values.used_for == "2" && 
            (vmsk > this.totalPrice - (this.totalDiscList - discExist) ||
              vmsk > plafon) 
            && (values.tax_bearer && values.tax_bearer!='1')
          ) {
            this.newLoading = false;
            //this.displayMessage("grather-remaining");
            this.displayMessageValue("error-other", "Total Tax values can't to be greather then Total Bill!");
            return;
          }
          //validasi discount : tidak boleh lebih dari total
          if (
            values.used_for == "1" &&
            vmsk > this.totalPrice - (this.totalDiscList - discExist)
          ) {
            this.newLoading = false;
            //this.displayMessage("grather-remaining");
            this.displayMessageValue("error-other", "Total Discount values can't to be greather then Total Bill!");
            return;
          }
          //validasi selain pajak dan discount : tidak boleh lebih dari plafon
          //console.log("validasi -",vmsk,plafon)
          if (
            values.used_for !== "2" &&
            values.used_for !== "1" &&
            vmsk > plafon
          ) {
            this.newLoading = false;
           // this.displayMessage("grather-remaining");
            this.displayMessageValue("error-other", "Total values can't to be greather then Total Bill!");
            // this.$nextTick(function () {
            //   this.modalForm.setFieldsValue({
            //     harga: null,
            //   });
            // });
            return;
          }

          // if (values.used_for=="1"){
          //   console.log("simulasiEditDiskon")
          //   let trig = this.simulasiEditDiskon(this.editData,values)
          //   if (!trig){
          //     this.displayMessage("grather-remaining");
          //     return
          //   }
          //   console.log("end simulasiEditDiskon")
          // }
          
          // if (this.isObject(this.selectedPNm)) {
          //   this.selectedPNm = this.selectedPNm.item_pn_concat;
          // }

          values.item_pn = this.selectedPNm;
          const newPush = this.listPembelian.filter(
            (item) => item.key !== id_key
          );

          values.type_item = values.is_aset=="yes" ? "1" : "0";

          let hargaTotal = 0;
          if (values.is_item == "yes") {
            hargaTotal = values.jumlah * values.harga;
          } else {
            let valh = values.harga;
            if (values.used_for == "2") {
              hargaTotal =
                values.cur_type == "percentage"
                  ? (valh *
                      (this.totalPrice
                        ? this.totalPrice - this.totalDiscList
                        : 0)) /
                    100
                  : valh;
            } else {
              hargaTotal =
                values.cur_type == "percentage"
                  ? (valh * (this.totalPrice ? this.totalPrice : 0)) / 100
                  : valh;
            }
          }
          if (this.mode == "Edit" && this.editData.values.id_po_dtl) {
            values.id_po_dtl = this.editData.values.id_po_dtl;
          }
          values.hargaTotal =  hargaTotal;
          values.pp_nama_barang = pp_nama_barang;
          values.pp_kode_anggaran = pp_kode_anggaran;
          //jika diatas lima juta diakui sebagai inventaris
          values.isinventaris = values.harga>=5000000? "0":"1";

          let isthis = [
            ...newPush,
            JSON.parse(JSON.stringify({ key: "other", values })),
          ];
          if (!this.simulation(isthis, values, "add")) {
            //this.displayMessage("grather-remaining");
            this.displayMessageValue("error-other", "Recounting value result is minus, check nominal again!");
            this.newLoading = false;
            return;
          }

          if(this.isDraftEdited){
              let formData = new FormData();
              formData.append('id_po', this.informasi.id_po);
              formData.append('id_po_dtl', this.editData.values.id_po_dtl);
              formData.append('is_item', values.is_item);
              formData.append('used_for', values.used_for);
              formData.append('id_pp_dtl', values.selectedPPdtl);
              formData.append('item_pn', values.item_pn);
              formData.append('nama_barang', values.nama_barang);
              formData.append('jumlah', values.jumlah);
              formData.append('hargaTotal', values.hargaTotal);
              formData.append('satuan', values.satuan);
              formData.append('unit_price', values.harga);
              formData.append('harga', values.harga);
              formData.append('isinventaris', values.isinventaris);
              formData.append('type_item', values.type_item);
              formData.append('catatan_dtl', values.catatan_dtl);

              formData.append('tax_bearer', values.tax_bearer);
              formData.append('tax_type', values.tax_type);

              this.asyncAxiosPost("po/dtl_draft_edit", "formdata", this.getAuth, formData)
              .then(() => {
                this.newLoading = false;
              })
              .catch((err) => {
                console.log(err);
                this.newLoading = false;
                return
              });
            }

          Event.$emit("updateList", newPush);

          Event.$emit("listPembelian", {
            key: id_key,
            hargaTotal: values.hargaTotal,
            item_name: values.nama_barang,
            selectedPPdtl: values.selectedPPdtl,
            unit_price: values.harga,
            values: values,
          });
          this.editModal = !this.editModal;
          this.modalconvert_value = 0;
          this.resetForm();
          this.displayMessageValue("update-item", values.nama_barang);
        }
      });
    },
    simulasiEditDiskon(valedit, val) {
      //validasi apabila dicount berubah dari percentage ke currency dan sebaliknya
      let result = true;
      if (val.used_for == "1") {
        //console.log("trig", valedit, val, this.getCountWeb);
        for (let index = 0; index < this.ppdetillist.length; index++) {
          this.ppdetillist[index].temp_remove_val =
            this.ppdetillist[index].nilai_dtl_pp;
        }

        //simulasi diskon dihapus untuk menghitung diskon yang baru
        this.getCountWeb.forEach((ment) => {
          let ppdtl = ment.values.selectedPPdtl;
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem == ppdtl) {
              let bsaran =
                (valedit.values.hargaTotal / this.totalPrice) *
                (valedit.cur_type == "percentage"
                  ? (valedit.values.harga * this.totalPrice) / 100
                  : valedit.values.harga);
              // console.log(
              //   "pertama-",
              //   valedit.values.hargaTotal,
              //   this.totalPrice,
              //   val.cur_type == "percentage"
              //     ? (valedit.values.harga * this.totalPrice) / 100
              //     : valedit.values.harga
              // );
              // console.log(
              //   this.ppdetillist[index].temp_remove_val,
              //   bsaran,
              //   this.ppdetillist[index].temp_remove_val - bsaran
              // );
              this.ppdetillist[index].temp_remove_val =
                this.ppdetillist[index].temp_remove_val - bsaran;
              if (this.ppdetillist[index].temp_remove_val < 0) {
                result = false;
              }
            }
          }
        });
        //console.log("this.ppdetillist", this.ppdetillist);

        //simulasi diskon yang baru
        this.getCountWeb.forEach((ment) => {
          let ppdtl = ment.values.selectedPPdtl;
          for (let index = 0; index < this.ppdetillist.length; index++) {
            const elem = this.ppdetillist[index].id_pp_dtl;
            if (elem == ppdtl) {
              //console.log("jos ndak");
              let bsaran =
                (ment.values.hargaTotal / this.totalPrice) *
                (val.cur_type == "percentage"
                  ? (val.harga * this.totalPrice) / 100
                  : val.harga);
              // console.log(
              //   "-",
              //   this.totalPrice,
              //   val.cur_type == "percentage"
              //     ? (val.harga * this.totalPrice) / 100
              //     : val.harga
              // );
              // console.log(
              //   this.ppdetillist[index].temp_remove_val,
              //   bsaran,
              //   this.ppdetillist[index].temp_remove_val - bsaran
              // );
              this.ppdetillist[index].temp_remove_val =
                this.ppdetillist[index].temp_remove_val + bsaran;
              if (this.ppdetillist[index].temp_remove_val < 0) {
                result = false;
              }
            }
          }
        });
      }
      return result;
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    handleDownload() {
      axios({
        method: "get",
        url: this.$serviceUrl + "/main/download_template_po?X-API-KEY=xxx",
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          window.open(this.$serviceUrl + response.data.url, "_blank");
        })
        .catch((err) => {
          this.displayMessage("error-emptyDocTemplate");
          console.log(err);
        });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();

          this.trigered.is_item = "yes";
          this.trigered.used_for = false;
          this.trigered.pn = true;
          this.trigered.cur = false;
          this.trigered.percentage = false;
          this.trigered.qty_unit = true;
          this.convert_value = 0;
          
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
      return false;
    },
    isObject(obj) {
      return obj === Object(obj);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleDetail(item) {
      this.selectedDetail = _.filter(
        this.ppdetillist,
        (data) => data.id_pp_dtl.toLowerCase().indexOf(item.toLowerCase()) >= 0
      );
    },
    handleDetail2(item) {
      if(item)
        this.selectedDetail2 = _.filter(
          this.ppdetillist,
          (data) => data.id_pp_dtl.toLowerCase().indexOf(item.toLowerCase()) >= 0
        );
    },
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
        //this.pagination.pageSize = 10;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
        //this.pagination.pageSize = 5;
      }
    },
    taxTypeChange(val){
      if ((val=="ppn") || val=="bea_masuk" || val=="pph_23"){
        this.trigered.dis_tax_type = true;
      }else{
        this.trigered.dis_tax_type = false;
      }

      if(val=="ppn" || val=="bea_masuk"){
        this.trigered.disabledTaxBearer=true;
        this.trigered.enablePPTaxBearer=true;
        this.$nextTick(function () {
          this.form.setFieldsValue({
            tax_bearer: '0',
          });
        });
      }else if(val=="pph_23"){
        this.trigered.disabledTaxBearer=false;
        this.trigered.enablePPTaxBearer=false;
          this.$nextTick(function () {
          this.form.setFieldsValue({
            tax_bearer: '0',
          });
        });
      }else{
        this.$nextTick(function () {
            this.form.setFieldsValue({
              tax_bearer: '1',
            });
          });
        this.trigered.disabledTaxBearer=false;
        // let sts = this.form.getFieldValue("tax_bearer");
        // if(sts=='0'){
        //   this.trigered.enablePPTaxBearer=false;
        //   this.trigered.dis_tax_type = false;
        // }else{
          this.trigered.enablePPTaxBearer=false;
          this.trigered.dis_tax_type = false;
        //}
      }

      if(val.includes("pph")){
        this.trigered.optionNominal=false;
        this.$nextTick(function () {
            this.form.setFieldsValue({
              cur_type: 'currency',
            });
          });
      }else{
        this.trigered.optionNominal=true;
      }
    },
    taxTypeChange2(val){
      if ((val=="ppn") || val=="bea_masuk" || val=="pph_23"){
        this.trigered.dis_tax_type = true;
      }else{
        this.trigered.dis_tax_type = false;
      }

      if(val=="ppn" || val=="bea_masuk"){
        this.trigered.disabledTaxBearer=true;
        this.trigered.enablePPTaxBearer=true;
          this.$nextTick(function () {
          this.form.setFieldsValue({
            tax_bearer: '0',
          });
        });
      }else if(val=="pph_23"){
        this.trigered.disabledTaxBearer=false;
        this.trigered.enablePPTaxBearer=false;
          this.$nextTick(function () {
          this.form.setFieldsValue({
            tax_bearer: '0',
          });
        });
      }else{
        this.trigered.disabledTaxBearer=false;
        let sts = this.modalForm.getFieldValue("tax_bearer");
        if(sts=='0'){
          this.trigered.enablePPTaxBearer=true;
          this.trigered.dis_tax_type = true;
        }else{
          this.trigered.enablePPTaxBearer=false;
          this.trigered.dis_tax_type = false;
        }
      }
    },
    toTextTax(val){
      let textReturn = _.filter(
              this.getType_tax, (obj) => obj.value == val.values.tax_type);
      return textReturn.length > 0 ? textReturn[0].text : '';
    },
    changeTaxBearer(val){
        if(val.target.value=='0'){
          this.trigered.enablePPTaxBearer=true;
          this.trigered.dis_tax_type = true;
        }else{
          this.trigered.enablePPTaxBearer=false;
          this.trigered.dis_tax_type = false;
        }
    },
  },
};
</script>

<style lang="less">
.footer-list {
  display: flex;
  justify-content: flex-end;
  .ant-row {
    width: 100%;
  }
}
.footer-light {
  font-size: medium;
}
.select-between {
  .ant-select-selection-selected-value {
    width: 100%;
  }
}

.option-between {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;

  &__left {
    width: 70%;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__right {
    width: 30%;
    overflow: hidden;
    position: relative;
    text-align: right;
    font-weight: bold;
  }

  .ant-select-selection-selected-value{
    width:100%!important
  }
}

.labelingInventaris{
    font-weight: 700;
    color: #8f8f8f!important;
    text-align: center;
}
</style>
